import { createFileRoute, Navigate } from "@tanstack/react-router"
import { GoalsListSearchSchema } from "./list/route"

export const Route = createFileRoute("/_base/_auth/campaigns/goals/")({
  component: RouteComponent,
})

function RouteComponent() {
  return <Navigate to="/campaigns/goals/list" search={GoalsListSearchSchema.parse({})} replace />
}
